import React from 'react';

import { HStack, Skeleton } from '@rtkwlf/fenrir-react';

export const HostDnsServersSkeleton = () => (
  <HStack
    width="full"
    data-testid="host-dns-servers-skeleton"
    marginBottom="medium"
  >
    <Skeleton
      margin="zero"
      flex="auto"
      height="2rem"
      width="30rem"
      borderRadius="default"
    />
    <Skeleton margin="zero" height="2rem" width="6rem" borderRadius="default" />
    <Skeleton margin="zero" height="2rem" width="6rem" borderRadius="default" />
  </HStack>
);
